// src/App.js
import React, { useState, useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import TimeTracking from './TimeTracking';
import ReportsStandalone from './ReportsStandalone';
import Employees from './Employees';
import Login from './Login';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4a5d8f',
    },
    secondary: {
      main: '#4caf50',
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Arial", sans-serif',
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState('timesheet');

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (err) {
        console.error('Error parsing stored user:', err);
        localStorage.removeItem('user');
      }
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    setIsAuthenticated(false);
    setCurrentPage('timesheet');
    localStorage.removeItem('user');
  };

  const handleNavigate = (page) => {
    console.log('🔵 [App.js] handleNavigate called with page:', page);
    console.log('🔵 [App.js] Current user:', user);
    console.log('🔵 [App.js] user.isAdmin:', user?.isAdmin);
    setCurrentPage(page);
    console.log('🔵 [App.js] currentPage state updated to:', page);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!isAuthenticated ? (
        <Login onLogin={handleLogin} />
      ) : (
        <>
          {console.log('🔵 [App.js] Rendering page. currentPage:', currentPage, 'user.isAdmin:', user?.isAdmin)}
          
          {currentPage === 'timesheet' && (
            <TimeTracking 
              user={user} 
              onLogout={handleLogout}
              onNavigate={handleNavigate}
            />
          )}
          
          {currentPage === 'reports' && (
            <ReportsStandalone 
              user={user} 
              onLogout={handleLogout}
              onNavigate={handleNavigate}
            />
          )}
          
          {currentPage === 'employees' && user?.isAdmin && (
            <>
              {console.log('🟢 [App.js] Rendering Employees component')}
              <Employees 
                user={user} 
                onLogout={handleLogout}
                onNavigate={handleNavigate}
              />
            </>
          )}
          
          {/* Redirect non-admins trying to access Employees */}
          {currentPage === 'employees' && !user?.isAdmin && (
            <>
              {console.log('🔴 [App.js] Non-admin tried to access Employees, redirecting to TimeTracking')}
              <TimeTracking 
                user={user} 
                onLogout={handleLogout}
                onNavigate={handleNavigate}
              />
            </>
          )}
        </>
      )}
    </ThemeProvider>
  );
}

export default App;